var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg004AHd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 378.667529,
    height: 378.667529,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823302,
    rx: 213.74094,
    id: "svg_5",
    cy: 225.79493,
    cx: 224.459066,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_3",
    height: 257.089961,
    width: 366.003714,
    y: 69.392955,
    x: 42.397986,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m400.135283,55.338082l0,-0.600854l-1.93064,0l-347.876078,0l-1.93064,0l0,0.600854c-11.381497,0.815013 -19.872833,10.24876 -21.222864,21.698557l0,2.015379l0,238.813691c0,4.630941 1.156709,8.534143 3.087349,12.04998c4.44189,8.14812 10.99872,12.26481 20.0668,12.26481l126.955694,0l0,33.362512l-24.116891,0c-5.980731,0 -10.611432,4.845772 -10.611432,11.063773c0,6.218002 4.630701,11.063102 10.611432,11.063102l142.198471,0c5.980731,0 10.805398,-4.845772 10.805398,-11.063102c0,-6.218673 -4.824023,-11.063773 -10.805398,-11.063773l-24.116891,0l0,-33.362512l126.95505,0c9.071946,0 15.686773,-4.11669 20.0668,-12.26481c1.987992,-3.687701 3.28067,-7.633198 3.28067,-12.04998l0,-238.81302l0,-2.015379c-1.350675,-11.450468 -10.418755,-20.884214 -21.41683,-21.699228zm0,23.714607l0,238.813691c0,1.415196 -0.576743,2.015379 -1.93064,2.015379l-347.876078,0c-1.35003,0 -1.93064,-0.600183 -1.93064,-2.015379l0,-238.813691l0,-2.015379l351.736714,0l0,2.015379l0.000644,0z",
    id: "svg_2",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    x1: 35.914127,
    y1: 395.528597,
    x2: 431.88195,
    y2: 400.367308,
    id: "svg_6",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    d: "m226.354187,135.954268l-154.640186,0c-3.681634,0 -6.665944,2.911566 -6.665944,6.502197l0,112.895167c0,3.590631 2.984311,6.502197 6.665944,6.502197l154.640765,0c3.681055,0 6.665944,-2.911002 6.665944,-6.502197l0,-112.895167c-0.000579,-3.590631 -2.985468,-6.502197 -6.666523,-6.502197zm-101.085785,88.351194l5.780547,-19.741413l-21.574188,0l-5.782861,19.741413l-13.241613,0l14.877573,-50.802825l13.245085,0l-6.121975,20.901976l21.57303,0l6.121975,-20.901976l13.246242,0l-14.881045,50.802825l-13.24277,0zm81.171283,-25.401413c-4.400368,15.022395 -18.898898,25.401413 -35.6387,25.401413l-21.872214,0l9.829649,-33.564298l13.241613,0l-6.810038,23.25584l9.448292,0c8.109779,0 15.698736,-6.094646 18.312105,-15.019009c2.635939,-9.000567 -1.65795,-15.16803 -10.065177,-15.16803l-22.099061,0l3.019032,-10.307329l22.395351,0c16.368282,0 24.657455,10.307329 20.239147,25.401413l0.000001,0z",
    id: "_x34_9-HD_icon"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0033",
    stroke: "null",
    id: "svg_1",
    d: "m371.557716,167.410749c-17.680868,-31.084566 -56.841732,-41.735567 -87.463532,-23.785622c-30.624246,17.94415 -41.117929,57.691993 -23.433798,88.775317c17.678421,31.084566 56.838062,41.737223 87.460269,23.788934c30.624654,-17.950359 41.12323,-57.696133 23.43706,-88.778629l0.000001,0zm-29.838402,77.518313c-24.495727,14.360287 -55.826294,5.838989 -69.969847,-19.029905c-14.146815,-24.863927 -5.748851,-56.665017 18.747691,-71.018267c24.497358,-14.359459 55.826294,-5.838989 69.970662,19.029077c14.144776,24.867653 5.749259,56.662119 -18.748506,71.019095zm-2.560618,-47.66438l-33.527422,-19.847844c-3.055288,-1.810558 -5.519664,-0.363022 -5.502536,3.224152l0.171687,39.395998c0.015497,3.586346 2.51005,5.046301 5.57431,3.249816l33.270912,-19.497654c3.060997,-1.793173 3.067522,-4.713909 0.01305,-6.524468l-0.000001,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004AHd);
export default __webpack_public_path__ + "static/media/004a-HD.06d1184970f85f098c9ad48579b1a62b.svg";
export { ForwardRef as ReactComponent };